import {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import config from "../config";
import { genericErrorMsg, getOnlandStatus } from "../utils.js";
import Button from "react-bootstrap/esm/Button.js";
import LoadingSpinner from "../components/LoadingSpinner.js";
import dayjs from 'dayjs';
import { Fragment } from "react";

export default function MyBookingCheckinPage() {

  let { bookingId } = useParams();

  const [booking, setBooking] = useState(null);
  const [offlandDates, setOfflandDates] = useState(null);

  const [saving, setSaving] = useState(false);

  const fetchBooking = () => {
    fetch(`${config.server_base_url}/api/my-booking/${bookingId}`)
        .then((response) => response.json())
        .then((data) => setBooking(data.booking))
        .catch(error => toast.error( genericErrorMsg, {theme: 'colored'}));
  }  

  const fetchOfflandDates = () => {
    fetch(`${config.server_base_url}/api/my-booking/${bookingId}/offlandDates`)
        .then((response) => response.json())
        .then((data) => setOfflandDates(data.offlandDates))
        .catch(error => toast.error( genericErrorMsg, {theme: 'colored'}));
  }  

  const getStatus = () => {
    const defaultOnland = booking.booking.roomBookings.length>0 && booking.booking.roomBookings[0].room.name.indexOf('ZPOWN')!=-1 ? false : true;
    return getOnlandStatus(booking.booking.guest, offlandDates, defaultOnland);
  }

  const saveCheckin = (checkin) => {
    setSaving(true);
    fetch(`${config.server_base_url}/api/my-booking/${booking.booking.id}/saveCheckin`, 
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          checkin: checkin
        })
      })
      .then((response) => response.json())
      .then((data) => { if (data.success) {fetchBooking();} else {setErrorMsg(data.reason); } setSaving(false); })
      .catch((error) => {setSaving(false); toast.error( genericErrorMsg, {theme: 'colored'})});
  }    

  useEffect(() => {
    fetchBooking();
    fetchOfflandDates();
  },[])

  return (
    <div className="app-container my-booking-app">
      <div className="page-container my-booking-page my-booking-checkin-page">  
          <h1><center>Sahaja Team Check In</center></h1>
          <h3><center>{booking ? `${booking.booking.guest.preferredName} ${booking.booking.guest.lastName}`  : <LoadingSpinner /> }</center></h3>
          <center><p className='form-info'>This page should accurately show whether you are on the land in Sahaja or not. Please use it to check in and check out. In case of a fire it's extremely important to come to this page and update your status as soon as possible. <br/><em>Please note that when you are on holiday you automatically appear as OFFLAND here.</em></p></center>
          {booking && offlandDates && getStatus()=='ON THE LAND' ? 
            <Fragment>
              <div className='checkInStatus onland'>{getStatus()}</div>
              {booking.booking.guest.checkedInTime!=null && dayjs(booking.booking.guest.checkedInTime).isAfter(dayjs().subtract(3, 'day'), 'day') ?
                <center>Last check in: {dayjs(booking.booking.guest.checkedInTime).format('ddd HH:mm')}</center> : <center></center>}
            </Fragment>: ''}
          {booking && offlandDates && getStatus().indexOf('OFFLAND')!=-1 ? 
            <Fragment>
              <div className='checkInStatus offland'>{getStatus()}</div>
              {booking.booking.guest.checkedOutTime!=null && dayjs(booking.booking.guest.checkedOutTime).isAfter(dayjs().subtract(3, 'day'), 'day') ?
                <center>Last check out: {dayjs(booking.booking.guest.checkedOutTime).format('ddd HH:mm')}</center> : <center></center>}
            </Fragment> : ''}              
          <center>
            {booking && offlandDates && getStatus()=='ON THE LAND' ? <Button style={{fontSize: 22, marginTop:20}} disabled={saving} onClick={()=>saveCheckin(false)}  variant="secondary" className='mb-2'>Check out</Button> : ''}
            {booking && offlandDates && getStatus().indexOf('OFFLAND')!=-1 ? <Button style={{fontSize: 22,marginTop:20}}  disabled={saving} onClick={()=>saveCheckin(true)} variant="success" className='mb-2'>Check in</Button> : ''}
          </center>
      </div>
      <ToastContainer />
    </div>
  )
}